import React from 'react';
import CustomIcon from '../custom_icon/custom_icon';

import styles from './top_back_btn.module.css';

const TopBackBtn = ({ text, onClick }) => {
  return (
    <button onClick={onClick} className={styles.button}>
      <div className={styles.icon}>
        <CustomIcon width={14} height={14} color='#9E9E9E' icon='arrow' />
      </div>

      {text}
    </button>
  );
};

export default TopBackBtn;
